import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ApiConfig } from '@sp-core/api-config';

@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(ApiConfig.baseAPIPath)) {
      return next.handle(req);
    }

    const bypassReq = req.clone({
      setHeaders: {
        'ngsw-bypass': 'true',
      },
    });
    return next.handle(bypassReq);
  }
}
